<template>
  <section class="shortcut-datetime">
    <el-date-picker
      clearable
      v-model="datetime"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      :picker-options="pickerOptions"
      @change="onDatetimeChange"
      :unlink-panels="true"
      ref="datePicker"
    ></el-date-picker>
  </section>
</template>
<script>
import dayjs from "dayjs";
export default {
  props: {
    currentDatetime: Array,
  },
  data() {
    return {
      datetime: [],
      pickerOptions: {},
    };
  },
  watch: {
    currentDatetime: {
      handler(newVal, oldVal) {
        if (Array.isArray(newVal)) {
          this.datetime = [...newVal];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.pickerOptions = {
      shortcuts: [
        {
          text: "去年",
          onClick: (picker) => {
            const currentYear = dayjs().year();
            const start = dayjs(`${currentYear - 1}-01-01`);
            const end = dayjs(`${currentYear - 1}-12-31`).endOf("day");
          
            picker.$emit("pick", [start, end]);
            this.$nextTick(() => {
              this.$refs.datePicker.focus();
            });
          },
        },
        {
          text: "上月",
          onClick: (picker) => {
            const lastMonthDate = dayjs().subtract(1, "month");
            const start = lastMonthDate.startOf("month");
            const end = lastMonthDate.endOf("month");
            picker.$emit("pick", [start, end]);
            this.$nextTick(() => {
              this.$refs.datePicker.focus();
            });
          },
        },
        {
          text: "上周",
          onClick: (picker) => {
            const lastWeekDate = dayjs().subtract(1, "week");
            const start = new Date(lastWeekDate.startOf("week"));
            const end = new Date(
              lastWeekDate.endOf("week").subtract(1, "millisecond")
            );

            picker.$emit("pick", [start, end]);
            this.$nextTick(() => {
            
              this.$refs.datePicker.focus();
            });
          },
        },
        {
          text: "昨天",
          onClick: (picker) => {
            const yesterday = dayjs().subtract(1, "day");
            const start = new Date(yesterday.startOf("day"));
            const end = new Date(
              yesterday.endOf("day").subtract(1, "millisecond")
            );
            picker.$emit("pick", [start, end]);
            this.$nextTick(() => {
              this.$refs.datePicker.focus();
            });
          },
        },
        {
          text: "今天",
          onClick: (picker) => {
            const start = new Date(dayjs().startOf("day"));
            const end = new Date(dayjs());
            picker.$emit("pick", [start, end]);
            this.$nextTick(() => {
              this.$refs.datePicker.focus();
            });
          },
        },
        {
          text: "本周",
          onClick: (picker) => {
            const start = new Date(dayjs().startOf("week"));
            const end = new Date(dayjs().subtract(1, "millisecond"));

            picker.$emit("pick", [start, end]);
            this.$nextTick(() => {
              this.$refs.datePicker.focus();
            });
          },
        },
        {
          text: "本月",
          onClick: (picker) => {
            const start = new Date(dayjs().startOf("month"));
            const end = new Date(dayjs().subtract(1, "millisecond"));

            picker.$emit("pick", [start, end]);
            this.$nextTick(() => {
              this.$refs.datePicker.focus();
            });
          },
        },
        {
          text: "本年",
          onClick: (picker) => {
            // 获取当前年份
            const currentYear = dayjs().year();
            const start = new Date(dayjs(`${currentYear}-01-01`));
            const end = new Date(dayjs().subtract(1, "millisecond"));
            picker.$emit("pick", [start, end]);
            this.$nextTick(() => {
              this.$refs.datePicker.focus();
            });
          },
        },
      ],
    };
  },
  methods: {
    onDatetimeChange(v) {
      this.$emit(
        "current-datetime-change",
        (v ?? []).map((date) => {
          if (date) return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
          return null;
        })
      );
    },
  },
};
</script>
<style>
.shortcut-datetime {
  display: inline-block;
}
.shortcut-datetime .el-date-editor.el-date-editor--datetimerange {
  width: auto;
  max-width: none;
}
</style>
